import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import BoundaryContext from './context';

/**
 * @ignore
 *
 * Set a named boundary that can be queried by one of the child components
 * through the `useBoundary` hook.
 *
 * @example
 * function Inner () {
 *   const isInsideWrapper = useBoundary('Wrapper')
 *
 *   return (
 *     <span style={{ color: isInsideWrapper ? 'red' : 'blue' }}>
 *       Inner
 *     </span>
 *   )
 * }
 *
 * function Wrapper () {
 *   return (
 *     <Boundary name="Wrapper">
 *       <Inner />
 *     </Boundary>
 *   )
 * }
 */
const Boundary = _ref => {
  let {
    name,
    children
  } = _ref;
  const {
    chainOfNames: parentNames
  } = useContext(BoundaryContext) || {
    chainOfNames: []
  };
  return /*#__PURE__*/React.createElement(BoundaryContext.Provider, {
    value: {
      chainOfNames: [name, ...parentNames]
    }
  }, children);
};
process.env.NODE_ENV !== "production" ? Boundary.propTypes = {
  /**
   * Sets the children.
   */
  children: PropTypes.node,
  /**
   * Sets the boundary name.
   */
  name: PropTypes.string.isRequired
} : void 0;
export default Boundary;